import { useEffect, useState } from "react";
import { OkendoIntegrationApi } from "./checkout-widgets-builder-context";

export type OkendoConnectionStatus =
  | { state: "loading" }
  | { state: "connected"; okendoUserId: string }
  | { state: "disconnected" };

export function useOkendoConnectionStatus(
  api: OkendoIntegrationApi | undefined,
): {
  status: OkendoConnectionStatus;
  setStatus: (status: OkendoConnectionStatus) => void;
  refresh: () => Promise<void>;
} {
  const [status, setStatus] = useState<OkendoConnectionStatus>({
    state: "loading",
  });

  useEffect(() => {
    if (!api) {
      setStatus({ state: "disconnected" });
      return;
    }
    let cancelled = false;
    void (async () => {
      try {
        const result = await api.get();
        if (cancelled) {
          return;
        }
        setStatus(
          result && result.enabled
            ? { state: "connected", okendoUserId: result.okendoUserId }
            : { state: "disconnected" },
        );
      } catch {
        if (!cancelled) {
          setStatus({ state: "disconnected" });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [api]);

  async function refresh() {
    if (!api) {
      return;
    }
    const result = await api.get();
    setStatus(
      result && result.enabled
        ? { state: "connected", okendoUserId: result.okendoUserId }
        : { state: "disconnected" },
    );
  }

  return { status, setStatus, refresh };
}
